module.exports = __webpack_public_path__ + "img/home_icon_pink.7c72d471.svg";